<template>
  <Transition name="entr-screen" mode="out-in" :duration="{ enter: 320, leave: 320 }">
    <slot />
  </Transition>
</template>
